import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { HStack, IconButton, Link } from "@chakra-ui/react";
import { FiEye } from "react-icons/fi";
import { BsCreditCard } from "react-icons/bs";

import { Invoice, InvoiceStatus } from "types/invoice";
import { getPayInvoiceLink } from "api/webservice/invoice";
import { useToast } from "hooks";

interface Props {
  invoice: Invoice;
}

const InvoiceActions: React.FC<Props> = ({
  invoice: { id, status }
}: Props) => {
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handlePayClick = (): void => {
    if (loading) return;
    setLoading(true);
    getPayInvoiceLink(id)
      .then(link => {
        setLoading(false);
        window.open(link, "_blank");
      })
      .catch(error => {
        setLoading(false);
        toast({
          title: "",
          description: error.response.data.response,
          status: "error"
        });
      });
  };

  return (
    <HStack spacing="2" justifyContent="flex-end">
      <Link as={RouterLink} to={`/invoice/${id}`}>
        <IconButton
          aria-label="View Invoice"
          icon={<FiEye />}
          isRound
          size="lg"
        />
      </Link>
      <IconButton
        aria-label="Pay Invoice"
        icon={<BsCreditCard />}
        isRound
        size="lg"
        onClick={handlePayClick}
        isLoading={loading}
        disabled={status == InvoiceStatus.Paid || status == InvoiceStatus.Void}
      />
    </HStack>
  );
};

export default InvoiceActions;
